<template>
  <Modal
    v-model="_value"
    width="870"
    title="配置定位设备"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <div style="position:relative;">
      <Table border highlight-row size="small" height="200" :columns="columns" :stripe="true" :data="content"
             ref="table"
             @on-sort-change="sortChange"></Table>
      <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
        <Spin size="large"></Spin>
        <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
      </div>
    </div>
    <Form autoComplete="on" class="card-box login-form">
      <Form-item label="设备主机号">
        <Select
          v-model="selectPositioningDeviceInfos"
          multiple
          filterable
          remote
          :remote-method="searchPositioningDeviceInfo"
          :loading="searchPositioningDeviceInfoLoading">
          <Option v-for="(option, index) in searchPositioningDeviceInfoList" :value="option.id" :key="option.id">
            {{option.terminalNum}}
          </Option>
        </Select>
      </Form-item>
    </Form>
    <Row type="flex" justify="end">
      <Button type="primary" @click="onBindPositioningDeviceInfos">绑定</Button>
    </Row>

    <positioning-device-info-detail-modal v-model="positioningDeviceInfoDetailModal"
                                          :initValue="positioningDeviceInfoDetailId"></positioning-device-info-detail-modal>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import PositioningDeviceInfoDetailModal from '@/view/im/components/positioning-device-info-detail-modal'

export default {
  name: 'AssembleSimModal',
  components: {
    PositioningDeviceInfoDetailModal
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {
      modify: false,
      positioningDeviceInfoDetailModal: false,
      positioningDeviceInfoDetailId: null,
      searchPositioningDeviceInfoList: [],
      searchPositioningDeviceInfoLoading: false,
      selectPositioningDeviceInfos: [],
      positioningDeviceInfoStateOptions: [
        { label: '未安装', value: 1 },
        { label: '已安装', value: 2 },
        { label: '损坏', value: 3 }
      ],
      // positioningDeviceModelOptions: [
      //   { label: 'BSJ-A6-BD', value: 1 },
      //   { label: 'BSJ-GF03', value: 2 },
      //   { label: 'BSJ-M11', value: 3 },
      //   { label: 'BSJ-A6L', value: 13 },
      //   { label: 'BSJ-A7', value: 14 },
      //   { label: 'K5', value: 4 },
      //   { label: 'D5X', value: 5 },
      //   { label: 'G-3G', value: 6 },
      //   { label: 'D5X-HDD', value: 7 },
      //   { label: 'D5X-XR', value: 8 },
      //   { label: 'BSJ-GF06', value: 9 },
      //   { label: 'BSJ-RM01', value: 10 },
      //   { label: 'HIK-A3', value: 11 },
      //   { label: 'HIK-A3L', value: 12 }
      // ],
      positioningDeviceSourceTypeOptions: [
        { label: '新装', value: 1 },
        { label: '接入', value: 2 }
      ],
      positioningDeviceInfo: {
        id: null,
        terminalNum: null,
        factoryTerminalNum: null,
        positioningDeviceModel: null,
        positioningDeviceModelId: null,
        sourceType: null,
        remark: null,
        setupDatetime: null,
        serviceDatetime: null
      },
      listLoadding: false,
      columns: [
        {
          title: 'ID',
          resizable: true,
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          minWidth: 70
        },
        {
          title: '主机号',
          resizable: true,
          key: 'terminalNum',
          ellipsis: 'true',
          minWidth: 160
        },
        {
          title: '状态',
          resizable: true,
          key: 'terminalNum',
          ellipsis: 'true',
          minWidth: 80,
          render: function (h, params) {
            if (params.row.serviceState == 0) {
              return h('div', '停止服务')
            } else if (params.row.serviceState == 1) {
              return h('div', '正常')
            }
          }
        },
        {
          title: '设备型号',
          resizable: true,
          key: 'positioningDeviceModelId',
          ellipsis: 'true',
          minWidth: 100,
          render: function (h, params) {
            if (params.row.positioningDeviceModel) {
              let positioningDeviceModel = params.row.positioningDeviceModel
              return h('div', positioningDeviceModel.name)
            }else {
              return h('div', '未知')
            }
            // let positioningDeviceModel = params.row.positioningDeviceModelId
            // if (positioningDeviceModel === 1) {
            //   return h('div', 'BSJ-A6-BD')
            // } else if (positioningDeviceModel === 2) {
            //   return h('div', 'BSJ-GF03')
            // } else if (positioningDeviceModel === 3) {
            //   return h('div', 'BSJ-M11')
            // } else if (positioningDeviceModel === 13) {
            //   return h('div', 'BSJ-A6L')
            // } else if (positioningDeviceModel === 14) {
            //   return h('div', 'BSJ-A7')
            // } else if (positioningDeviceModel === 4) {
            //   return h('div', 'K5')
            // } else if (positioningDeviceModel === 5) {
            //   return h('div', 'D5X')
            // } else if (positioningDeviceModel === 6) {
            //   return h('div', 'G-3G')
            // } else if (positioningDeviceModel === 7) {
            //   return h('div', 'D5X-HDD')
            // } else if (positioningDeviceModel === 8) {
            //   return h('div', 'D5X-XR')
            // } else if (positioningDeviceModel === 9) {
            //   return h('div', 'BSJ-GF06')
            // } else if (positioningDeviceModel === 10) {
            //   return h('div', 'BSJ-RM01')
            // } else if (positioningDeviceModel === 11) {
            //   return h('div', 'HIK-A3')
            // } else if (positioningDeviceModel === 12) {
            //   return h('div', 'HIK-A3L')
            // } else {
            //   return h('div', '未知')
            // }
          }
        },
        {
          title: '备注',
          resizable: true,
          key: 'remark',
          ellipsis: 'true',
          tooltip: 'true',
          minWidth: 100
        },
        {
          title: '设备来源',
          resizable: true,
          key: 'sourceType',
          ellipsis: 'true',
          minWidth: 100,
          render: function (h, params) {
            let sourceType = params.row.sourceType
            if (sourceType === 1) {
              return h('div', '新装')
            } else if (sourceType === 2) {
              return h('div', '接入')
            }
          }
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          minWidth: 220,
          render: (h, params) => {
            let display = []

            // return h('div', [
            display.push(
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.positioningDeviceInfoDetailId = params.row.id
                    this.positioningDeviceInfoDetailModal = true
                  }
                }
              }, '详细信息')
            )
            if (params.row.serviceState == 0) {
              display.push(
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      console.log(params.row)
                      this.$Modal.confirm({
                        title: '提示',
                        content: '<p>确认重新开通服务</p>',
                        okText: '是',
                        cancelText: '否',
                        onOk: () => {
                          store.dispatch('PositioningDeviceInfoServ_ReopeningState', {
                            params: {
                              id: params.row.id
                            },
                            urlparams: null
                          }).then(res => {
                            console.log(res)
                            this.$Message.success('重新开通成功')
                          }).catch(err => {
                            console.log(err)
                          })
                        },
                        onCancel: () => {

                        }
                      })
                    }
                  }
                }, '重新开通')
              )
            }
            display.push(
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '确认解绑设备',
                      content: '<p>确认解绑设备</p>',
                      onOk: () => {
                        store.dispatch('VehicleInfoServ_UnBindPositioningDeviceInfos', {
                          params: { id: this._initValue, positioningDeviceInfoIds: [params.row.id] }
                        }).then(() => {
                          this.$Message.success('修改成功')
                          this.updateTable()
                          this.$emit('on-success')
                        }).catch(err => {
                          this.$Message.error(err)
                          this.$emit('on-fail')
                        })
                      },
                      onCancel: () => {

                      }
                    })
                  }
                }
              }, '解绑')
            )
            // ])

            return h('div', display)
          }
        }
      ]
    }
  },
  methods: {
    ...mapActions([
      'PositioningDeviceInfoServ_GetDetail',
      'PositioningDeviceInfoServ_ModifyObj',
      'VehicleInfoServ_BindPositioningDeviceInfos',
      'VehicleInfoServ_UnBindPositioningDeviceInfos',
      'PositioningDeviceInfoServ_GetAll'
    ]),
    onBindPositioningDeviceInfos () {
      this.$Modal.confirm({
        title: '确认绑定设备',
        content: '<p>确认绑定设备</p>',
        onOk: () => {
          store.dispatch('VehicleInfoServ_BindPositioningDeviceInfos', {
            params: { id: this._initValue, positioningDeviceInfoIds: this.selectPositioningDeviceInfos }
          }).then(() => {
            this.$Message.success('修改成功')
            this.updateTable()
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {

        }
      })
    },
    searchPositioningDeviceInfo (input) {
      this.searchPositioningDeviceInfoLoading = true
      if (!input || input.length <= 0) {
        this.searchPositioningDeviceInfoList = []
        this.searchPositioningDeviceInfoLoading = false
      } else {
        store.dispatch('PositioningDeviceInfoServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchPositioningDeviceInfoList = store.getters.get_PositioningDeviceInfo_SearchByNameResult ? store.getters.get_PositioningDeviceInfo_SearchByNameResult : []
          this.searchPositioningDeviceInfoLoading = false
        }).catch(err => {
          this.searchPositioningDeviceInfoLoading = false
        })
      }
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage()
    },
    updateTable () {
      this.listLoadding = true
      let queryParams = []
      let sortParam = null
      queryParams.push(genQueryParam('vehicleInfoId', 'EQ', this._initValue))
      store.dispatch('PositioningDeviceInfoServ_GetAll', {
        params: null,
        urlparams: {
          q: queryParams,
          keyword: null,
          sort: sortParam
        }
      }).then(() => {
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    visibleChange (val) {
      if (val) {
        let vehicleInfoId = this._initValue
        if (vehicleInfoId) {
          this.searchPositioningDeviceInfoList = []
          this.selectPositioningDeviceInfos = []
          this.listLoadding = true
          let queryParams = []
          let sortParam = null
          queryParams.push(genQueryParam('vehicleInfoId', 'EQ', vehicleInfoId))
          store.dispatch('PositioningDeviceInfoServ_GetAll', {
            params: null,
            urlparams: {
              q: queryParams,
              keyword: null,
              sort: sortParam
            }
          }).then(() => {
            this.listLoadding = false
          }).catch(err => {
            this.listLoadding = false
            this.$Message.error(err)
          })
        }
      }
    }
  },
  computed: {
    content () {
      if (store.getters.get_PositioningDeviceInfo_GetAllResult) {
        return store.getters.get_PositioningDeviceInfo_GetAllResult
      } else {
        return []
      }
    },
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
